import { apiPost, throwApiError } from "../utils";

export const createNotification = async (data) => {
  const response = await apiPost(`/admin/notifications`, data);

  const { message, ...report } = await response.json();

  throwApiError(message);

  return report;
};
